import "./style.css";

export default function Sell() {
  return (
    <div className="container" id="sell">
      <div className="content">
        <div className="cards">
          <div className="card">
            <div className="card-header">
              <h3 className="plan-title" id="tier-hobby">Plano Oportunidade</h3>
              <div className="price">
                10x de R$360,54
                <span className="price-period">ou R$3000,00 à vista</span>
              </div>
              <p className="description">Você está prestes a transformar sua vida profissional</p>
            </div>
            <div className="card-body">
              <div className="features">
                <ul className="feature-list">
                  <li className="feature-item success">Marketing no Instagram</li>
                  <li className="feature-item success">Precificação estratégica</li>
                  <li className="feature-item success">Posicionamento e autoridade</li>
                  <li className="feature-item success">Captação de clientes premium</li>
                </ul>
                <div className="button-wrapper">
                  <a href="https://pay.kiwify.com.br/VLnPSmE" className="button">Quero ser quem sempre sonhei</a>
                </div>
              </div>
            </div>
          </div>

          {/* <div className="card">
            <div className="card-header">
              <h3 className="plan-title" id="tier-team">Plano Protagonista</h3>
              <div className="price">
                10x de R$480,72
                <span className="price-period">ou R$4000,00 à vista</span>
              </div>
              <p className="description">Para quem almeja mais</p>
            </div>
            <div className="card-body">
              <div className="features">
                <ul className="feature-list">
                  <li className="feature-item success">Item 1</li>
                  <li className="feature-item success">Item 2</li>
                  <li className="feature-item success">Item 3</li>
                  <li className="feature-item success">Item 4</li>
                </ul>
                <div className="button-wrapper">
                  <a href="https://pay.kiwify.com.br/AQKYGBt" className="button">Quero ser quem sempre sonhei</a>
                </div>
              </div>
            </div>
          </div> */}

        </div>
      </div>
    </div>
  );
};